import React from 'react'
import { FormattedNumber } from 'react-intl'
import { linearGradientDef } from '@nivo/core'
import { ResponsiveBar } from '@nivo/bar'
import styles from './BarChart.scss'

interface BarChartTooltipProps {
  value: number
  tooltipLabel?: string
}

const BarChartTooltip: React.FC<BarChartTooltipProps> = ({ value, tooltipLabel }) => (
  <span className={styles.barCustomTooltip}>
    {tooltipLabel}: <FormattedNumber value={value} />
  </span>
)

interface BarChartDataItem {
  [key: string]: string | number
  key: string
}

interface BarChartProps {
  withLabel?: boolean
  enableGridY?: boolean
  keys?: string[]
  indexBy?: string
  padding?: number
  data: BarChartDataItem[]
  tooltipLabel?: string
  xLabelsRotation?: number
  clickOnGraph?: (data: any, event: React.MouseEvent) => void
}

const BarChart: React.FC<BarChartProps> = ({
  withLabel = false,
  enableGridY = true,
  keys = ['count'],
  indexBy = 'key',
  padding = 0.4,
  data,
  tooltipLabel,
  xLabelsRotation = -90,
  clickOnGraph = () => {},
}) => (
  <div className={styles.wrapper}>
    <ResponsiveBar
      animate
      enableGridY={enableGridY}
      data={data}
      keys={keys}
      indexBy={indexBy}
      margin={{ top: 20, right: 20, bottom: 30, left: 60 }}
      borderRadius={2}
      padding={padding}
      colors={['#6480E2']}
      motionStiffness={90}
      motionDamping={15}
      enableLabel={withLabel}
      borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
      axisBottom={{
        tickSize: 0,
        tickRotation: xLabelsRotation,
      }}
      axisLeft={{
        tickSize: 0,
      }}
      tooltip={(props) => <BarChartTooltip {...props} tooltipLabel={tooltipLabel} />}
      onClick={clickOnGraph}
      defs={[
        linearGradientDef('arrows', [
          { offset: 0, color: 'inherit', opacity: 0.4 },
          { offset: 100, color: 'inherit', opacity: 0.8 },
        ]),
      ]}
      fill={[
        {
          match: {
            id: 'count',
          },
          id: 'arrows',
        },
      ]}
    />
  </div>
)

export default BarChart

